import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { memberAPI } from '../../services/api';
import toast from 'react-hot-toast';

export const fetchMemberDashboard = createAsyncThunk('member/fetchDashboard', async (_, { rejectWithValue }) => {
  try {
    const response = await memberAPI.getDashboard();
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch dashboard');
  }
});

export const updateMemberProfile = createAsyncThunk('member/updateProfile', async (profileData, { rejectWithValue }) => {
  try {
    const response = await memberAPI.updateProfile(profileData);
    toast.success('Profile updated successfully!');
    return response.data.member;
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update profile';
    toast.error(message);
    return rejectWithValue(message);
  }
});

const memberSlice = createSlice({
  name: 'member',
  initialState: {
    dashboard: null,
    sessions: [],
    progress: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMemberDashboard.pending, (state) => { state.loading = true; })
      .addCase(fetchMemberDashboard.fulfilled, (state, action) => { state.loading = false; state.dashboard = action.payload; })
      .addCase(fetchMemberDashboard.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(updateMemberProfile.fulfilled, (state, action) => {
        if (state.dashboard && state.dashboard.member) {
          state.dashboard.member = action.payload;
        }
      });
  },
});

export const { clearError } = memberSlice.actions;
export const selectMemberDashboard = (state) => state.member.dashboard;
export const selectMemberLoading = (state) => state.member.loading;
export default memberSlice.reducer;
